//@ts-check
import createBatchAction from '@/common/lib/create-batch-action';
import { showLoading, hideLoading } from '@/common/components/kf-loader';
import { updateResult } from '../result/result.action';
import { errorHandler } from '../ajax';
export const illegalMailRequest = createBatchAction('@illegal-mail/ILLEGAL_MAIL_REQUEST', () => [showLoading()]);
export const illegalMailSuccess = createBatchAction('@illegal-mail/ILLEGAL_MAIL_SUCCESS', () => [hideLoading(), updateResult('送信しました。')]);
export const illegalMailFailure = createBatchAction('@illegal-mail/ILLEGAL_MAIL_FAILURE', (err) => [hideLoading(), errorHandler(err)]);